import daterangepicker from 'daterangepicker';
import IMask from 'imask';
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import skLocale from '@fullcalendar/core/locales/sk';
import csLocale from '@fullcalendar/core/locales/cs';
import googleCalendarPlugin from '@fullcalendar/google-calendar';

Calendar.name;

window.$ = window.jQuery = require('jquery');
window.Swal = require('sweetalert2');
window.toastr = require("toastr");
window.Ladda = require('ladda');
window.moment = require("moment");
window.daterangepicker = daterangepicker;
window.googleMap = require("./vendor/googlemaps/jquery.googlemap");
window.IMask = IMask;
window.Calendar = Calendar;
window.dayGridPlugin = dayGridPlugin;
window.timeGridPlugin = timeGridPlugin;
window.interactionPlugin = interactionPlugin;
window.listPlugin = listPlugin;
window.skLocale = skLocale;
window.csLocale = csLocale;
window.googleCalendarPlugin = googleCalendarPlugin;

require('./bootstrap')

// CoreUI
require('@coreui/coreui-pro');
window.Utils = require("@coreui/utils");

// Boilerplate
require('./plugins');
require('bootstrap-datepicker');

// Alpine is bundled with and started by Livewire 3; importing it here too
// would initialise Alpine twice.
